<template>
  <div class="flex flex-col w-full mb-1">
    <data-field :label="$t('components.company.crm.keyEntered')">
      {{ flowfactConfig.token?.length > 0 ? $t('components.company.crm.yes') : $t('components.company.crm.no') }}
    </data-field>
    <data-field :label="$t('components.company.crm.keyValid')">
      {{ flowfactConfig.isTokenVerified ? $t('components.company.crm.yes') : $t('components.company.crm.no') }}
    </data-field>
    <data-field :label="$t('components.company.crm.selectedTags')">
      {{ statuses }}
    </data-field>
  </div>
</template>

<script>
import FLOWFACT_CONFIG from '@/graphql/FlowfactConfig.gql'
import FLOWFACT_CONTACT_TAGS from '@/graphql/FlowfactContactTags.gql'
import DataField from '@/components/data-field'

export default {
  components: {
    DataField
  },
  props: {
    companyId: { type: String, default: '' }
  },
  data () {
    return {
      flowfactConfig: { selectedContactStatusIds: [] },
      flowfactContactTags: []
    }
  },
  computed: {
    statuses () {
      const flowfactContactTagsMap = new Map([
        ...this.flowfactContactTags.map(status => [status.id, status.name]),
        ['ALL', this.$t('components.company.crm.allContacts')],
        ['UNDEFINED', this.$t('components.company.crm.contactsWithoutTags')]
      ])
      return this.flowfactConfig.selectedContactStatusIds.map(id => flowfactContactTagsMap.get(id)).join(', ')
    }
  },
  apollo: {
    flowfactConfig: {
      query: FLOWFACT_CONFIG,
      variables () {
        return {
          companyId: this.companyId
        }
      }
    },
    flowfactContactTags: {
      query: FLOWFACT_CONTACT_TAGS,
      variables () {
        return {
          companyId: this.companyId
        }
      }
    }
  }
}
</script>
